import request from '@/utils/request'

export default {
  getPlanOption () {
    return request.get('/api/v1/qp/plans')
  },
  getTargetCategoryData () {
    return request.get('/api/v1/qp/plans/target_categories')
  },
  getTarget ({ targetId, planId, categoryId }) {
    if (targetId !== -1) {
      let params = { target_id: targetId }
      if (planId !== -1) {
        params.plan_id = planId
      }
      if (categoryId !== -1) {
        params.category_id = categoryId
      }
      return request.get('/api/v1/qp/plans/target_options', { params })
    } else {
      console.log('target_id cant be -1')
      return Promise.reject(new Error('target_id cant be -1'))
    }
    // return request.get('/api/v1/qp/plans/target_options', { params: { 'target_id': 2, 'plan_id': 2 } })
  }
}
